<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <el-button type="primary" @click="add()" class="header-btn">新建</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="templateList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="模板id" prop="id"></el-table-column>
<!--            <el-table-column label="模板号" prop="channelTemplateNo"></el-table-column>-->
            <el-table-column label="模板名称" prop="channelTemplateName"></el-table-column>
            <el-table-column label="短信内容" prop="template"></el-table-column>
            <el-table-column label="埋点ID" prop="chanId"></el-table-column>
            <!--<el-table-column prop="validateCodeKey" label="模板验证key"></el-table-column>-->
            <!--<el-table-column prop="validateCodeExpire" label="验证码过期时间"></el-table-column>-->
            <el-table-column prop="appId" label="应用id"></el-table-column>
            <el-table-column prop="appName" label="应用名称"></el-table-column>
            <el-table-column prop="createDate" label="创建时间">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.createDate)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="updateDate" label="更新时间">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.updateDate)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="edit(scope.row)">修改</el-button>
                        <!--<el-button type="primary" size="mini" @click="toOrderDetail(scope.row.orderMainNo)">订单详情</el-button>-->
                    </el-button-group>

                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="模板设置" :visible.sync="showDialog">
            <el-form :model="templateModel" label-width="120px">
                <el-form-item label="模板名称" prop="name">
                    <el-input v-model="templateModel.name" placeholder="模板名称"></el-input>
                </el-form-item>
                <el-form-item label="短信模板内容" prop="template">
                    <el-input v-model="templateModel.template" placeholder="短信模板内容"></el-input>
                </el-form-item>
              <el-form-item label="短信模板URL" prop="shortLink">
                <el-input v-model="templateModel.shortLink" placeholder="短信模板URL"  @input="urlChange()"></el-input>
                可填写短链接，也可填写长链接，长链接自动转短链接发送，同时长链接支持参数 ${mobile}
                <el-tag type="success" @click="mobileClick('mobile=${mobile}')">mobile参数</el-tag>
              </el-form-item>
              <el-form-item label="埋点ID/chan_id" prop="chanId">
                <el-input v-model="templateModel.chanId" placeholder="chan_id"></el-input>必填
              </el-form-item>
                <el-form-item label="模板号" prop="channelTemplateNo">
<!--                    <el-input v-model="templateModel.channelTemplateNo" placeholder="模板号"></el-input>-->
                    <el-select v-model="templateModel.channelTemplateNo" placeholder="请选择模板" filterable clearable>
                        <el-option v-for="item in channelTemplateList" :key="item.tplId" :label="item.tplName" :value="item.tplId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应用" prop="appName">
                    <el-input v-model="formInline.appName" disabled="disabled" placeholder="appName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="saveTemplate()" class="header-btn">
                        保存模板
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getTemplateListApi, saveTemplateApi, getAppListApi, getMyTemplatesList
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    appId: "",
                    appName: "",
                },
                templateList: [],
                channelTemplateList : [],
                templateModel: {
                    id: '',
                    template: '',
                    shortLink:'',
                    chanId:'',
                    channelTemplateNo: '',
                    channelTemplateName: '',
                    name: '',
                    type: 1,
                    validateCodeKey: '',
                    validateCodeExpire: 0,
                    appId: 0
                },
                loading: true,
                recordsTotal: 0,
                rules: {
                    template: [
                        {required: true, message: '请输入模板名称', trigger: 'blur'},
                        {min: 1,max: 400, message: '长度在 1 到 400 个字符', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '请输入模板名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.formInline.appId = this.$route.query.appId;
            this.formInline.appName = this.$route.query.appName;
            this.getTemplateList();
            this.getMyTemplatesList();
        },
        methods: {
            getMyTemplatesList(){
                getMyTemplatesList().then((res) => {
                    if (res.data.success) {
                        console.log("智齿彩信模板",res.data.value);
                        this.channelTemplateList = res.data.value.data;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getTemplateList(){
                //查询模板列表
                getTemplateListApi(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.recordsTotal = res.data.value.total;
                        this.templateList = res.data.value.list;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getTemplateList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getTemplateList()
            },
            add(){
                this.templateModel = {
                    id: '',
                    template: '',
                    shortLink:'',
                    channelTemplateNo: '',
                    channelTemplateName: '',
                    name: '',
                    type: 1,
                    validateCodeKey: '',
                    validateCodeExpire: 0,
                    appId: this.formInline.appId
                };
                this.showDialog = true;
            },
            edit(row){
                this.templateModel = {
                    id: row.id,
                    template: row.template,
                    shortLink:row.shortLink,
                    channelTemplateNo: row.channelTemplateNo,
                    channelTemplateName: row.channelTemplateName,
                    name: row.name,
                    type: row.type,
                    chanId:row.chanId,

                    validateCodeKey: row.validateCodeKey,
                    validateCodeExpire: row.validateCodeExpire,
                    appId: this.formInline.appId
                };
                this.showDialog = true;
            },
            saveTemplate(){
                //模板内容判空
                if(this.templateModel.template==''){
                    this.$message({
                        message: '模板不能为空',
                        type: 'error'
                    });
                    return;
                }
                console.log(this.templateModel.chanId);
              if(this.templateModel.chanId=='' || this.templateModel.chanId==undefined){
                this.$message({
                  message: '埋点ID不能为空',
                  type: 'error'
                });
                return;
              }
                //保存应用
                // if(this.templateModel.template.length>70){
                //     this.$message({
                //         message: '模板内容建议不超过70个字符',
                //         type: 'error'
                //     });
                //     return;
                // }
                //模板名称判空
                if(this.templateModel.name==''){
                    this.$message({
                        message: '名称不能为空',
                        type: 'error'
                    });
                    return;
                }
                for (var i = 0 ; i < this.channelTemplateList.length ; i++){
                    if(this.channelTemplateList[i].tplId == this.templateModel.channelTemplateNo){
                        this.templateModel.channelTemplateName = this.channelTemplateList[i].tplName;
                    }
                }
                this.loading=true;
                //保存
                saveTemplateApi(this.templateModel).then((res) => {
                    console.log(res);
                    this.loading=false;
                    if (res.data.success) {
                        this.getTemplateList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            returnHistory(){
                window.history.back()
            },
          mobileClick(c){
              if(this.templateModel.shortLink!=''){
                  if(this.templateModel.shortLink.indexOf(c)>=0){//存在
                    this.templateModel.shortLink=this.templateModel.shortLink.replace("&"+c,"").replace("?"+c,"");
                  }else {
                    if(this.templateModel.shortLink.indexOf("?")>=0){
                      this.templateModel.shortLink=this.templateModel.shortLink+"&"+c;
                    }else{
                      this.templateModel.shortLink=this.templateModel.shortLink+"?"+c;
                    }
                  }
              }
          },
          urlChange(){
              if(this.templateModel.shortLink!=''){
                var sp=this.templateModel.shortLink.split('chan_id=');
                if(sp.length>1){
                  var s=sp[1].split('&');
                  this.templateModel.chanId=s[0];
                }
              }
          }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/template.vue